export default function printManagedTicket(elementId) {
  const ticket = document.getElementById(elementId);
  if (!ticket) throw new Error('No se encontro el contenido del ticket.');
  const printed = document.createElement('div');
  printed.innerHTML = ticket.innerHTML;
  const original = document.createDocumentFragment();
  // Preserve Vue's actual nodes and listeners while showing only the ticket.
  while (document.body.firstChild) original.appendChild(document.body.firstChild);
  try {
    document.body.appendChild(printed);
    window.print();
  } finally {
    printed.remove();
    document.body.appendChild(original);
  }
}
